import { jsx as _jsx } from "react/jsx-runtime";
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createHeadingNode } from '@lexical/rich-text';
import { $setBlocksType } from '@lexical/selection';
import { $createParagraphNode, $getSelection, $isRangeSelection } from 'lexical';
import { useCallback } from 'react';
import { Dropdown } from 'libs.nucleus';
import { FormatterWrapper } from './formatter_wrapper';
export const FormatHeading = () => {
    const [editor] = useLexicalComposerContext();
    const apply = useCallback((tag) => {
        editor.update(() => {
            const selection = $getSelection();
            if (!$isRangeSelection(selection)) {
                return;
            }
            $setBlocksType(selection, () => (tag === 'paragraph' ? $createParagraphNode() : $createHeadingNode(tag)));
        });
    }, [editor]);
    return (_jsx(FormatterWrapper, { children: _jsx(Dropdown, { variant: 'icon', iconName: 'fontSize', iconSize: 20, label: 'Format heading', items: [
                { id: 'paragraph', content: 'Paragraph', onClick: () => apply('paragraph') },
                { id: 'h1', content: 'Heading 1', onClick: () => apply('h1') },
                { id: 'h2', content: 'Heading 2', onClick: () => apply('h2') },
                { id: 'h3', content: 'Heading 3', onClick: () => apply('h3') },
            ], "aria-label": 'Format heading' }) }));
};
